'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

const ProfileSection = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [profile, setProfile] = useState({
    name: 'John Traveler',
    email: 'john.traveler@example.com',
    phone: '+44 7445 270141',
    memberSince: 'January 2024',
    totalBookings: 12,
    countriesVisited: 8,
    loyaltyPoints: 2450,
  });

  return (
    <div className="space-y-6">
      {/* Profile Header */}
      <div className="flex flex-col lg:flex-row items-start lg:items-center gap-6 p-6 bg-gradient-to-br from-primary/5 to-accent/5 rounded-xl border border-primary/20">
        <div className="w-24 h-24 bg-gradient-to-br from-primary to-secondary rounded-full flex items-center justify-center text-white text-3xl font-black shadow-lg">
          {profile.name.split(' ').map(n => n[0]).join('')}
        </div>
        <div className="flex-1">
          <h2 className="text-2xl font-black text-foreground mb-1">{profile.name}</h2>
          <p className="text-muted-foreground mb-3">Member since {profile.memberSince}</p>
          <div className="flex flex-wrap gap-4">
            <div className="flex items-center gap-2 text-sm">
              <Icon name="EnvelopeIcon" size={16} className="text-primary" />
              <span>{profile.email}</span>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <Icon name="PhoneIcon" size={16} className="text-primary" />
              <span>{profile.phone}</span>
            </div>
          </div>
        </div>
        <button
          onClick={() => setIsEditing(!isEditing)}
          className="px-6 py-2.5 bg-primary text-white font-bold rounded-lg hover:bg-secondary transition-all duration-200 shadow-md hover:shadow-lg"
        >
          {isEditing ? 'Save Changes' : 'Edit Profile'}
        </button>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="p-6 bg-white rounded-xl border border-border shadow-sm hover:shadow-md transition-shadow">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-12 h-12 bg-sky-blue/10 rounded-lg flex items-center justify-center">
              <Icon name="TicketIcon" size={24} className="text-sky-blue" />
            </div>
            <div>
              <p className="text-3xl font-black text-foreground">{profile.totalBookings}</p>
              <p className="text-sm text-muted-foreground">Total Bookings</p>
            </div>
          </div>
        </div>

        <div className="p-6 bg-white rounded-xl border border-border shadow-sm hover:shadow-md transition-shadow">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-12 h-12 bg-accent/10 rounded-lg flex items-center justify-center">
              <Icon name="GlobeAltIcon" size={24} className="text-accent" />
            </div>
            <div>
              <p className="text-3xl font-black text-foreground">{profile.countriesVisited}</p>
              <p className="text-sm text-muted-foreground">Countries Visited</p>
            </div>
          </div>
        </div>

        <div className="p-6 bg-white rounded-xl border border-border shadow-sm hover:shadow-md transition-shadow">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-12 h-12 bg-trust-green/10 rounded-lg flex items-center justify-center">
              <Icon name="StarIcon" size={24} className="text-trust-green" />
            </div>
            <div>
              <p className="text-3xl font-black text-foreground">{profile.loyaltyPoints.toLocaleString()}</p>
              <p className="text-sm text-muted-foreground">Loyalty Points</p>
            </div>
          </div>
        </div>
      </div>

      {/* Recent Activity */}
      <div className="p-6 bg-white rounded-xl border border-border">
        <h3 className="text-xl font-black text-foreground mb-4 flex items-center gap-2">
          <Icon name="ClockIcon" size={24} className="text-primary" />
          Recent Activity
        </h3>
        <div className="space-y-3">
          {[
            { action: 'Booked flight to Paris', date: '2 days ago', icon: 'CheckCircleIcon', color: 'text-trust-green' },
            { action: 'Saved trip to Tokyo', date: '5 days ago', icon: 'BookmarkIcon', color: 'text-accent' },
            { action: 'Updated travel preferences', date: '1 week ago', icon: 'Cog6ToothIcon', color: 'text-primary' },
          ].map((activity, index) => (
            <div key={index} className="flex items-center gap-3 p-3 bg-surface rounded-lg">
              <Icon name={activity.icon as any} size={20} className={activity.color} />
              <div className="flex-1">
                <p className="font-semibold text-foreground">{activity.action}</p>
                <p className="text-sm text-muted-foreground">{activity.date}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProfileSection;